import { AuthPermission } from "common/constants";
import React from "react";
import { connect } from "react-redux";
import { apiToken } from "services/legit/token";
import { RootState } from "StoreTypes";
import Configuration from "../Configuration";
import PermissionErrorState from "../../components/PermissionErrorState";
import usePermissions from "../../hooks/usePermissions";

export interface Props {
  token: string | null;
}

const Home = ({ token }: Props) => {
  const { hasPermission } = usePermissions();

  return (
    <>
      {hasPermission(AuthPermission.FileStorageAdmin) ? (
        <Configuration token={token} />
      ) : (
        <PermissionErrorState />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: apiToken(state),
});

export default connect(mapStateToProps)(Home);
